export const LANDING_URL = import.meta.env.VITE_LANDING_URL as string;
export const INSTAGRAM = 'https://instagram.com/voluntariosacb';
export const TWITTER = 'https://x.com/voluntariosacb';
export const TIKTOK = 'https://www.tiktok.com/@voluntariosacb';
export const EMAIL_CONTACT = 'voluntariosacb@acb.es';
export const LEGAL_NOTICE = `${LANDING_URL}/files/aviso-legal.pdf`;

export const API_URL = import.meta.env.VITE_API_URL as string;
export const SIGNIN_URL = import.meta.env.VITE_SIGNIN_URL as string;
export const SIGNUP_URL = import.meta.env.VITE_SIGNUP_URL as string;